export const ImageWithFallback = ({src, fallback, ...rest}) => {
    const handleImageError = fallback => event => event.target.src = fallback;
    
    return <img src={src} onError={handleImageError(fallback)} {...rest} alt={rest?.alt}/>
}